import IconChevronLeft16 from '@warp-ds/icons/react/chevron-left-16';
import { Button } from '@warp-ds/react';
import ExitWithConfirmation from './ExitConfirmation.js';
import { ComponentProps } from 'react';
import IconClose16 from '@warp-ds/icons/react/close-16';

interface Props {
    /** The unClick function and screen reader text for the back button */
    prevButton?: Required<Pick<ComponentProps<typeof Button>, 'children' | 'onClick'>>;
    /** The unClick function and screen reader text for the exit button */
    exitButton?: Required<Pick<ComponentProps<typeof Button>, 'children' | 'onClick'>>;
    /** Texts for an optinal confirm modal before exiting. If undefined the flow will be exited staight away */
    confirmExitModal?: { title: string; confirm: string; abort: string };
}

const TopNavigator = ({ prevButton, exitButton, confirmExitModal }: Props) => {
    const spacing = prevButton ? 'justify-between' : 'justify-end';

    return (
        <nav className={`flex ${spacing} items-center mb-12 -mx-10 -mt-8`}>
            {prevButton && (
                <Button onClick={prevButton.onClick} quiet className="justify-self-start">
                    <IconChevronLeft16 className="s-text-link" />
                    <span className="sr-only">{prevButton.children}</span>
                </Button>
            )}
            {exitButton && (
                <ExitWithConfirmation
                    onExitFlow={{
                        ...exitButton,
                        children: (
                            <>
                                <IconClose16 className="s-text-link" />
                                <span className="sr-only">{exitButton.children}</span>
                            </>
                        ),
                    }}
                    confirmModal={confirmExitModal}
                />
            )}
        </nav>
    );
};

export default TopNavigator;
